import React, { useEffect } from 'react';
import Grid from '@mui/material/Grid2';
import ClearIcon from '@mui/icons-material/Clear';
import { Alert, IconButton, LinearProgress, Paper, Tooltip, Typography } from '@mui/material'
import FileTypes from 'Constants/FileTypes';
import { useLanguage } from 'Context/LanguageContext';
import { FielderButton } from 'FielderComponents';
import FileIcon from './components/FileIcon';
import { styled } from '@mui/material/styles';

const ProgressTextTitle = styled(Typography)`
	color: #969696;
	font-family: 'Lato';
	font-size: 0.92rem;
	font-style: italic;
`;

const FilenameText = styled(Typography)`
	font-family: 'Lato';
	font-size: 1rem;
	font-weight: 500;
`;

const getFileSize = (size) => {
	const fileSizes = ['Bytes', 'KB', 'MB', 'GB'];

	let i = 0;
	while (size > 900) {
		size /= 1024;
		i++;
	}

	return `${Math.round(size * 100) / 100  } ${  fileSizes[i]}`;
};

const FilePreview = ({ fileInfo, file, progress, removeFile, submitFile, setError }) => {
	const lan = useLanguage();

	const fileType = fileInfo.type;

	useEffect(() => {
		setError(fileType === FileTypes.ERROR_TYPE);
	}, [fileType]);

	const ProgressText = ({ children, className }) => (
		<Grid size={2}>
			{progress >= 0 && (
				<ProgressTextTitle variant='subtitle2' className={className}>
					{children}
				</ProgressTextTitle>
			)}
		</Grid>
	);

	const ProgressBar = () => (
			<div className='mb-3'>
				<Grid container direction='row'>
					<Grid size={12}>
						{progress >= 0 && (
							<LinearProgress variant='determinate' value={progress} className='mx-2' />
						)}
					</Grid>
				</Grid>
				<Grid container direction='row' justifyContent='space-between' className='pl-2 mt-2'>
					<ProgressText>{`${progress} %`}</ProgressText>
					<ProgressText className='ml-auto'>{getFileSize(fileInfo.size)}</ProgressText>
				</Grid>
			</div>
		);

	const FileUploadInfo = () => (
		<>
			<Grid container direction='row' justifyContent='center' alignItems='center' className='pl-3'>
				<Grid size={10}>
					<FilenameText variant='subtitle1'>
						{fileInfo.name}
					</FilenameText>
				</Grid>
				<Grid size={2}>
					{file !== null && (
						<Tooltip title={lan.cancel}>
							<IconButton onClick={removeFile}>
								<ClearIcon />
							</IconButton>
						</Tooltip>
					)}
				</Grid>
			</Grid>
			<ProgressBar />
		</>
	);

	return (
		<Paper className='my-3 py-3' elevation={4}>
			<Grid
				container
				direction='row'
				justifyContent='center'
				alignItems='center'
				style={{ minHeight: '70px' }}
			>
				<Grid size={2}>
					<FileIcon type={fileType} />
				</Grid>
				<Grid size={8} className='px-3'>
					<FileUploadInfo />
				</Grid>
			</Grid>

			{fileInfo.type === FileTypes.ERROR_TYPE && (
				<Grid container direction='row' justifyContent='center' className='my-2'>
					<Grid size={10}>
						<Alert severity='warning'>{lan.unsupportedFileType}</Alert>
					</Grid>
				</Grid>
			)}

			<Grid container direction='row' justifyContent='center'>
				<Grid size={3}>
					{fileInfo.type === FileTypes.ERROR_TYPE ? (
						<FielderButton outlined onClick={removeFile}>
							{lan.return}
						</FielderButton>
					) : (
						<FielderButton onClick={submitFile}>{lan.saveFile}</FielderButton>
					)}
				</Grid>
			</Grid>
		</Paper>
	);
};

export default FilePreview;
